// @ts-nocheck
import React from 'react';
import ComingSoonPage from './ComingSoonPage';

const ResourcesPlaceholder: React.FC = () => (
  <ComingSoonPage
    title="Resources"
    description="Event inventory & signage, staffing, travel, officials, scorekeepers, checklists, and expenses."
    sections={[
      'Overview',
      'Inventory & Signage',
      'Staffing',
      'Travel',
      'Officials',
      'Scorekeepers',
      'Checklists',
      'Expenses',
    ]}
  />
);

export default ResourcesPlaceholder;
